const getUnit = (unit?: string): string => {
  return unit ? `${unit}/` : '';
};

const getStreetNumer = (streetNumber?: string): string => {
  return streetNumber ? `${streetNumber} ` : '';
};

const getStreetName = (streetName?: string): string => {
  return streetName ? streetName : '';
};

const getShippingAddress = (data: {
  unit?: string;
  streetNumber?: string;
  streetName: string;
}): string => {
  return `${getUnit(data.unit)}${getStreetNumer(data.streetNumber)}${getStreetName(data.streetName)}`;
};

export { getUnit, getStreetNumer, getStreetName, getShippingAddress };
